import React, { Component } from 'react'
import { Table } from 'antd'

import Detail from './Detail'

class Graph extends Component<any> {
    state = {
        graph: {
            PRIVATE: { id: 1, name: 'PRIVATE', policies: [], price: 0, percentage: 0 },
            SHABAN: { id: 2, name: 'SHABAN', policies: [], price: 0, percentage: 0 },
            PUBLIC: { id: 3, name: 'PUBLIC', policies: [], price: 0, percentage: 0 },
            GROUP: { id: 4, name: 'GROUP', policies: [], price: 0, percentage: 0 },
            DEFENSE: { id: 5, name: 'DEFENSE', policies: [], price: 0, percentage: 0 }
        },
        policyTypes: {
            PRIVATE: 'ביטוח פרטי',
            SHABAN: 'המשלים של קופת חולים',
            PUBLIC: 'ביטוח ממלכתי',
            GROUP: 'ביטוח קבוצתי',
            DEFENSE: 'משרד הביטחון'
        },
        notificationsTypes: {
            missing: 'חשד לכפל חסר',
            salary: 'חסרים נתוני שכר'
        }
    }

    componentDidMount() {
        this.buildGraph()
    }

    componentDidUpdate(prevProps) {
        // Rebuild only when the incoming list reference changes (avoids an
        // expensive JSON.stringify diff and prevents render loops).
        if (prevProps.list !== this.props.list) {
            this.buildGraph()
        }
    }

    buildGraph = () => {
        const { list } = this.props
        let price = 0
        let graph = {
            PRIVATE: { id: 1, name: 'PRIVATE', policies: [], price: 0, percentage: 0 },
            SHABAN: { id: 2, name: 'SHABAN', policies: [], price: 0, percentage: 0 },
            PUBLIC: { id: 3, name: 'PUBLIC', policies: [], price: 0, percentage: 0 },
            GROUP: { id: 4, name: 'GROUP', policies: [], price: 0, percentage: 0 },
            DEFENSE: { id: 5, name: 'DEFENSE', policies: [], price: 0, percentage: 0 }
        }
        ;(list || []).forEach(policy => {
            const bucket = graph[policy.policy_type]
            // Guard unknown policy_type values that have no matching bucket.
            if (!bucket) return
            bucket.policies.push(policy)
            if (policy.policy_type !== 'DEFENSE') {
                bucket.price += policy.policy_price
                price += policy.policy_price
            }
        })
        Object.entries(graph).forEach(([key, value]) => {
            // Avoid NaN/Infinity when the total price is zero.
            graph[key].percentage = price ? ((value.price / price) * 100).toFixed(2) : '0.00'
            graph[key].price = graph[key].price.toFixed(2)
            if (!value.policies.length) delete graph[key]
        })
        this.setState({ graph })
    }
    render() {
        const { notifications, loading } = this.props
        const { graph, notificationsTypes, policyTypes } = this.state
        const columns = [
            {
                title: 'סוג ביטוח',
                key: 'name',
                width: 150,
                align: 'right',
                render: (_, record) => <div>{policyTypes[record.name]}</div>
            },
            {
                title: 'מחיר',
                width: 150,
                key: 'price',
                align: 'right',
                render: (_, record) => <div>{record.price}</div>
            },
            {
                title: 'אחוז מכלל התיק הביטוחי',
                width: 150,
                key: 'percentage',
                align: 'right',
                render: (_, record) => <div>{record.percentage}</div>
            },
            {
                title: 'לפירוט',
                width: 350,
                key: 'policies',
                align: 'right',
                render: (_, record) => (
                    <div>
                        <Detail policies={record.policies} />
                    </div>
                )
            }
        ]
        return (
            <>
                <Table
                    className="center-table"
                    style={{ width: '100%' }}
                    rowKey="id"
                    loading={loading}
                    columns={columns}
                    dataSource={Object.values(graph)}
                    pagination={{
                        total: Object.values(graph).length,
                        pageSize: 20,
                        current: 1,
                        hideOnSinglePage: true
                    }}
                />
                {Object.keys(notifications || {}).map((notification, ind) => (
                    <h6 key={ind} style={{ color: 'red' }}>
                        {notificationsTypes[notification]}
                    </h6>
                ))}
            </>
        )
    }
}

export default Graph
